import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import {
  useClientGoogleFonts,
  prepareBrandStylesForConsumer
} from '@getbento/website-components';

import { getBetaFeatureFlags } from 'bento-ordering/account/reducers';
import { getBrandFonts, getBrandStyles } from 'bento-ordering/brand/selectors';
import { hasBrandEngineFeature } from 'helpers/featureFlags/hasBrandEngineFeature';
import { usePreviewModeDataContext } from 'contexts/PreviewModeDataContext/index';

const useBrandData = () => {
  const { previewData } = usePreviewModeDataContext();
  const [styles, setStyles] = useState({});

  const betaFeatureFlags = useSelector(getBetaFeatureFlags);
  const isFeatureEnabled = hasBrandEngineFeature(betaFeatureFlags);
  const brandFonts = useSelector(getBrandFonts);
  const brandStyles = useSelector(getBrandStyles);

  const fonts = !isEmpty(previewData?.brandFonts)
    ? previewData.brandFonts
    : brandFonts;

  useClientGoogleFonts({ isFeatureEnabled, brandFonts: fonts });

  const stylesToProcess = !isEmpty(previewData?.brandStyles)
    ? previewData?.brandStyles
    : brandStyles;

  useEffect(() => {
    if (!isFeatureEnabled) {
      return null;
    }

    setStyles(prepareBrandStylesForConsumer(stylesToProcess));
  }, [isFeatureEnabled, stylesToProcess]);

  return {
    hasFeature: isFeatureEnabled,
    fonts,
    styles
  };
};

export default useBrandData;
